import script from "./ChannelExpansion.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChannelExpansion.vue?vue&type=script&lang=ts&setup=true"

import "./ChannelExpansion.vue?vue&type=style&index=0&id=6b7b218e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7b218e"]])

export default __exports__